<script>
  import Callout from '@components/general/callout.svelte'
  import { Sparkles } from 'lucide-svelte'

  let { class: className = "" } = $props()
</script>

<Callout class={className}
  title="Upgrade your membership"
  description="Get full access to all videos, resources and live sessions."
  buttonProps={{ text: "Upgrade", path: "/register" }}
  Icon={Sparkles} />
